import React, { useState } from 'react';

import {
  PlusSquareOutlined,
  MinusSquareOutlined,
  EditOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { useMutation } from '@apollo/client';
import {
  Controller,
  SubmitHandler,
  useFieldArray,
  useForm,
} from 'react-hook-form';

import { Button, Loading, Spinner } from '../../../../components';
import { Product } from '../ExternalMitigationTable';
import {
  UPDATE_EXTERNAL_MITIGATION_DIVISION,
  UPDATE_EXTERNAL_MITIGATION_PRODUCT,
  UPDATE_EXTERNAL_MITIGATION_PRODUCT_GROUP,
} from '../../queries';
import { UPDATE_EXTERNAL_MITIGATION_COMMENT } from '../../queries/Mitigation';
import Sucess from '../../../../components/generic/sucess';

interface ExternalMitigationFormProps {
  onCancel: () => void;
  data?: Product;
  product?:
    | 'MitigationDivision'
    | 'MitigationProductGroup'
    | 'MitigationProduct'
    | '';
  divisionId: string;
  locationId: string;
  external?: boolean;
  isEditing: boolean;
}

export function ExternalMitigationForm({
  onCancel,
  data,
  product,
  locationId,
  isEditing,
}: ExternalMitigationFormProps) {
  const mutation =
    product === 'MitigationDivision'
      ? UPDATE_EXTERNAL_MITIGATION_DIVISION
      : product === 'MitigationProductGroup'
      ? UPDATE_EXTERNAL_MITIGATION_PRODUCT_GROUP
      : UPDATE_EXTERNAL_MITIGATION_PRODUCT;
  const [UpdateExternalMitigationMatrix, { loading, error }] = useMutation(
    mutation,
    {
      refetchQueries: ['GetInternalMitigationMatrix'],
    },
  );
  const [sucess, setSucess] = useState(false);
  const [
    UpdateExternalMitigationCommentInput,
    { loading: loadingUpdateComment },
  ] = useMutation(UPDATE_EXTERNAL_MITIGATION_COMMENT, {
    refetchQueries: ['GetInternalMitigationMatrix'],
  });
  const { register, control, handleSubmit, getValues } = useForm({
    defaultValues: data,
  });
  const [editingFields, seteditingFields] = useState(
    (data?.vendors || [])?.map((item: any) => false),
  );
  const { fields } = useFieldArray({
    control,
    name: 'vendors',
  });

  if (loading) return <Spinner />;
  if (error) return <>Error! {error.message}</>;

  const onFinish: SubmitHandler<Product> = async (values) => {
    let response;

    values?.vendors?.map(async (item) => {
      const delay = parseFloat(item.delay.toString());
      const percentage = parseFloat(item.percentage.toString());
      const changeValue = data?.vendors?.find(
        (vendor) =>
          vendor.key === item.key &&
          (vendor.delay !== delay || vendor.percentage !== percentage),
      );

      console.log('former data: ', {
        data: [
          {
            delay: delay,
            percentage: percentage,
            locationAux: {
              uuid: '',
            },
            vendor: {
              uuid: item.key,
            },
          },
        ],
        division: {
          uuid: data?.key!,
        },
        location: {
          uuid: locationId,
        },
      });
      if (product == 'MitigationDivision' && changeValue) {
        try {
          response = await UpdateExternalMitigationMatrix({
            variables: {
              data: {
                data: [
                  {
                    delay: delay,
                    percentage: percentage,
                    locationAux: {
                      uuid: '',
                    },
                    vendor: {
                      uuid: item.key,
                    },
                  },
                ],
                division: {
                  uuid: data?.key!,
                },
                location: {
                  uuid: locationId,
                },
              },
            },
          });
          if (response?.data) onCancel();
        } catch (e) {
          console.log(e);
        }
      } else if (product === 'MitigationProductGroup' && changeValue) {
        try {
          response = await UpdateExternalMitigationMatrix({
            variables: {
              data: {
                data: [
                  {
                    delay: delay,
                    percentage: percentage,
                    locationAux: {
                      uuid: '',
                    },
                    vendor: {
                      uuid: item.key,
                    },
                  },
                ],
                productGroup: {
                  uuid: data?.key!,
                },
                location: {
                  uuid: locationId,
                },
              },
            },
          });
          if (response?.data) onCancel();
        } catch (e) {
          console.log(e);
        }
      } else if (product === 'MitigationProduct' && changeValue) {
        try {
          response = await UpdateExternalMitigationMatrix({
            variables: {
              data: {
                data: [
                  {
                    delay: delay,
                    percentage: percentage,
                    locationAux: {
                      uuid: '',
                    },
                    vendor: {
                      uuid: item.key,
                    },
                  },
                ],
                product: {
                  uuid: data?.key!,
                },
                location: {
                  uuid: locationId,
                },
              },
            },
          });
          if (response?.data) onCancel();
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  const enableEdit = (index: number) => {
    seteditingFields(
      editingFields?.map((item: any, i: number) =>
        i === index ? !item : item,
      ),
    );
  };

  const createComment = async (index: number) => {
    const values = getValues();

    if (!values.vendors) {
      return;
    }

    const { externalMitigationUUID, comment } = values.vendors[index];
    const ObjectToSend = {
      externalMitigation: { uuid: externalMitigationUUID },
      comment,
    };

    try {
      await UpdateExternalMitigationCommentInput({
        variables: { input: ObjectToSend },
      });
    } catch (error) {
      console.log(error);
    }

    setSucess(true);
    setTimeout(() => {
      setSucess(false);
      enableEdit(index);
    }, 2000);
  };

  return (
    <form
      className="  w-full flex flex-col flex-nowrap mt-2"
      onSubmit={handleSubmit(onFinish)}
    >
      <h1 className="  font-bold text-lg tracking-widest">{data?.name}</h1>
      <div className="w-full relative my-4">
        {isEditing && (
          <>
            <span className="  font-bold text-sm text-primary-200 absolute right-60">
              Mitigation
            </span>
            <span className="  font-bold text-sm text-primary-200 absolute right-12">
              Ramp-up
            </span>
          </>
        )}
      </div>
      {
        data?.vendors?.map((vendor, index) => (
          <div className="inline-flex flex-row flex-nowrap items-center my-2 justify-between">
            <label
              className="font-semibold text-primary-200 text-sm"
              htmlFor={vendor.key}
            >
              {vendor.vendorName}
            </label>
            {isEditing ? (
              <>
                <div>
                  <span className="mx-4 w-28 border rounded-lg text-right text-primary-200 font-normal text-sm px-2 py-2 h-auto">
                    <input
                      placeholder="100 %"
                      className="w-24 bg-transparent border-none text-right text-primary-200 font-normal text-sm focus:outline-none focus:ring-0"
                      type="number"
                      step={0.01}
                      id={vendor.key}
                      defaultValue={vendor.percentage}
                      {...register(`vendors.${index}.percentage`, {
                        required: true,
                        min: {
                          value: 0,
                          message: 'Percentage must be greater than 0.',
                        },
                        max: {
                          value: 100,
                          message: 'Percentage must be less than 100.',
                        },
                      })}
                    />
                    %
                  </span>
                  <span className="mx-4 w-28 border rounded-lg text-right text-primary-200 font-normal text-sm px-2 py-2 h-auto">
                    <input
                      placeholder="5 mths"
                      className="w-24 bg-transparent border-none text-right text-primary-200 font-normal text-sm focus:outline-none focus:ring-0"
                      type="number"
                      step={0.01}
                      id={vendor.key}
                      defaultValue={vendor.delay}
                      {...register(`vendors.${index}.delay`, {
                        required: true,
                        min: {
                          value: 0,
                          message: 'Delay must be greater than 0.',
                        },
                      })}
                    />
                    mths
                  </span>
                </div>
              </>
            ) : (
              <>
                {editingFields[index] && loadingUpdateComment ? (
                  <Loading />
                ) : sucess && editingFields[index] ? (
                  <Sucess />
                ) : (
                  <section
                    className={`relative ${isEditing ? 'w-7/12' : 'w-3/4'} `}
                  >
                    <Controller
                      control={control}
                      defaultValue={vendor?.comment || ''}
                      name={`vendors.${index}.comment`}
                      render={({ field }) => (
                        <TextArea
                          autoSize={{
                            minRows: !editingFields[index] ? 2 : 4,
                            maxRows: !editingFields[index] ? 2 : 6,
                          }}
                          readOnly={isEditing || !editingFields[index]}
                          className={`rounded-lg pr-8 w-full `}
                          id={`comment-${vendor.key}`}
                          {...field}
                        />
                      )}
                    />
                    <div
                      className={`bg-white absolute ${
                        editingFields[index]
                          ? ' top-[2px]'
                          : 'top-1/2 -translate-y-1/2'
                      } transform  right-3`}
                    >
                      {!editingFields[index] ? (
                        !isEditing ? (
                          <EditOutlined
                            className="text-blue hover:cursor-pointer"
                            onClick={() => enableEdit(index)}
                          />
                        ) : (
                          <PlusSquareOutlined
                            className="text-blue hover:cursor-pointer"
                            onClick={() => enableEdit(index)}
                          />
                        )
                      ) : !isEditing ? (
                        <SaveOutlined
                          className="text-blue hover:cursor-pointer"
                          onClick={() => createComment(index)}
                        />
                      ) : (
                        <MinusSquareOutlined
                          className="text-blue hover:cursor-pointer"
                          onClick={() => enableEdit(index)}
                        />
                      )}
                    </div>
                  </section>
                )}
              </>
            )}
          </div>
        ))!
      }
    </form>
  );
}
